import React from 'react';

const ActionButton = ({cachedData, onClick, label, className, style, disabled, fontIcon}) => {

    const clickHandler = (event) => {
        event.preventDefault();

        if (onClick){
            onClick(cachedData)
        }
    };

    return (
        <button type="button"
                onClick={clickHandler}
                style={style}
                disabled={disabled}
                className={className}>
            {fontIcon} {label}
        </button>
    );
};

export default ActionButton;
